import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Box } from '@chatterbug/aaron'

import { t } from 'src/lib/i18n-react'

const Countdown = ({ toTime }) => {
  const [time, setTime] = useState()
  const pad = (num, onlyIfZero = false) => {
    if (onlyIfZero && num !== 0) {
      return num.toString()
    }

    return num.toString().padStart(2, '0')
  }

  useEffect(() => {
    let timerInterval
    const countdown = () => {
      const total = Date.parse(toTime) - Date.parse(new Date()) //milliseconds
      const seconds = Math.floor((total / 1000) % 60)
      const minutes = Math.floor((total / 1000 / 60) % 60)
      if (total < 1) {
        setTime(`00:00`)
        clearInterval(timerInterval)
      } else {
        setTime(`${pad(minutes, true)}:${pad(seconds)}`)
      }
    }
    timerInterval = setInterval(countdown, 1000)
    countdown()
    return () => clearInterval(timerInterval)
  }, [toTime])

  return (
    <Box as="h3" variant="text.h3" color="white100">
      {`${time} ${t('min')}`}
    </Box>
  )
}

Countdown.propTypes = {
  toTime: PropTypes.string,
}

export default Countdown
